import { deleteField, doc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore'
import { db } from './config'

// FE-owned user state ABOUT a canonical meal, kept OFF the engine-owned meal doc: mutable state there
// would go stale in the MealsProvider freeze-cache and fight the "only the engine writes this" invariant.
// Writes are eager and read-free. The doc is created on first touch, hence setDoc with { merge: true }.

// Toggle a meal's favorite flag. `favoritedAt` is stamped when favoriting and
// cleared when un-favoriting, so the "old favorites" shelf can order by it. The
// heart is its own inverse, so this needs no memento.
export async function setMealFavorite(uid: string, mealId: string, favorite: boolean): Promise<void> {
  await setDoc(
    doc(db, 'users', uid, 'meal_user_state', mealId),
    { mealId, favorite, favoritedAt: favorite ? serverTimestamp() : deleteField() },
    { merge: true }
  )
}

// Hide a meal from the library ("remove from library"). Soft by design — the
// canonical meal doc is never deleted (meals are durable, past plans keep
// rendering them), so this only sets a tombstone the library filters on.
export async function hideMeal(uid: string, mealId: string): Promise<void> {
  await setDoc(doc(db, 'users', uid, 'meal_user_state', mealId), { mealId, hiddenAt: serverTimestamp() }, { merge: true })
}

// Undo of hideMeal: clear the tombstone so the meal reappears. The doc always
// exists here (hide created/merged it), so a plain field-removing update suffices.
export async function unhideMeal(uid: string, mealId: string): Promise<void> {
  await updateDoc(doc(db, 'users', uid, 'meal_user_state', mealId), { hiddenAt: deleteField() })
}

// Rate a meal 1–5, or clear the rating with null. Clearing removes the key, keeping the doc sparse.
export async function setMealRating(uid: string, mealId: string, rating: number | null): Promise<void> {
  await setDoc(doc(db, 'users', uid, 'meal_user_state', mealId), { mealId, rating: rating ?? deleteField() }, { merge: true })
}
